import React, { useCallback } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Form, Field } from 'react-final-form';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'modules/main';

import { parseFloat } from 'modules/main/formaters';
import { Modal, Button, FormRadioButton } from 'modules/ui/components';
import {
  settingsWindSpeedCorrectionSelector,
  saveSettingsThunk,
  settingsTimeResoulutionDefaultSelector,
} from 'modules/settings';
import ResolutionChartElement from 'modules/home/components/ResolutionChartElement';
import { TimeResolution } from 'modules/meteo/consts';
import WindSpeedCorrections from '../WindSpeedCorrections';

import {
  MultiRow,
  ScaleContainer,
  FooterContainer,
  RadioButtonWrapper,
} from './styledComponents';

type Props = {
  isOpen: boolean;
  closeModal: () => void;
};

const SettingsModal: React.FC<Props> = ({ isOpen, closeModal }) => {
  const dispatch = useAppDispatch();
  const windSpeedCorrection = useSelector(settingsWindSpeedCorrectionSelector);
  const timeResolution = useSelector(settingsTimeResoulutionDefaultSelector);
  const onSubmit = useCallback(
    async (data) => {
      dispatch(saveSettingsThunk(data));
      closeModal();
    },
    [closeModal, dispatch],
  );

  return (
    <Modal
      isOpen={isOpen}
      width={730}
      title="Settings"
      closeModal={closeModal}
      onRequestClose={closeModal}
    >
      <Form
        onSubmit={onSubmit}
        initialValues={{ windSpeedCorrection, timeResolution }}
        render={({ handleSubmit, invalid }): React.ReactNode => (
          <>
            <Tabs>
              <TabList>
                <Tab>Wind speed corrections</Tab>
                {false && <Tab>Timeline resolution</Tab>}
              </TabList>
              <TabPanel forceRender>
                <WindSpeedCorrections />
              </TabPanel>
              {false && (
                <TabPanel forceRender>
                  <div>
                    <MultiRow>
                      <RadioButtonWrapper>
                        <Field
                          name="timeResolution"
                          component={FormRadioButton}
                          label="High (1h / 3h / 6h)"
                          value={TimeResolution.high}
                          type="radio"
                          parse={parseFloat}
                        />
                      </RadioButtonWrapper>
                      <ScaleContainer>
                        <ResolutionChartElement backgroundColor="#6C120A" />

                        <ResolutionChartElement backgroundColor="#C7291C" />

                        <ResolutionChartElement backgroundColor="#EB3A2E" />
                      </ScaleContainer>
                    </MultiRow>
                    <MultiRow>
                      <RadioButtonWrapper>
                        <Field
                          name="timeResolution"
                          component={FormRadioButton}
                          label="Medium (3h / 3h / 6h)"
                          value={TimeResolution.medium}
                          type="radio"
                          parse={parseFloat}
                        />
                      </RadioButtonWrapper>
                      <ScaleContainer>
                        <ResolutionChartElement backgroundColor="#C7291C" />
                        <ResolutionChartElement backgroundColor="#C7291C" />
                        <ResolutionChartElement backgroundColor="#EB3A2E" />
                      </ScaleContainer>
                    </MultiRow>
                    <MultiRow>
                      <RadioButtonWrapper>
                        <Field
                          name="timeResolution"
                          component={FormRadioButton}
                          label="Low (3h / 6h / 12h)"
                          value={TimeResolution.low}
                          type="radio"
                          parse={parseFloat}
                        />
                      </RadioButtonWrapper>
                      <ScaleContainer>
                        <ResolutionChartElement backgroundColor="#C7291C" />
                        <ResolutionChartElement backgroundColor="#EB3A2E" />
                        <ResolutionChartElement backgroundColor="#F1A29F" />
                      </ScaleContainer>
                    </MultiRow>
                    <MultiRow>
                      <RadioButtonWrapper>
                        <Field
                          name="timeResolution"
                          component={FormRadioButton}
                          label="Superlow (12h / 12h / 12h)"
                          value={TimeResolution.superlow}
                          type="radio"
                          parse={parseFloat}
                        />
                      </RadioButtonWrapper>
                      <ScaleContainer>
                        <ResolutionChartElement backgroundColor="#F1A29F" />
                        <ResolutionChartElement backgroundColor="#F1A29F" />
                        <ResolutionChartElement backgroundColor="#F1A29F" />
                      </ScaleContainer>
                    </MultiRow>
                  </div>
                </TabPanel>
              )}
            </Tabs>
            <FooterContainer>
              <Button label="Cancel" isSecondary clickHandler={closeModal} />
              <Button
                label="Save"
                disabled={invalid}
                clickHandler={handleSubmit}
              />
            </FooterContainer>
          </>
        )}
      />
    </Modal>
  );
};

export default React.memo(SettingsModal);
